import { useQuery } from '@tanstack/react-query';
import { stringify as toQueryString } from '@AppModels/QueryStringUtils';
import { useApiClientContext } from '../../surveys/context';

const QUERY_KEY = 'SharedFileLink/byToken/logo';

export const useSharedFileLinkLogoByToken = ({ token, enabled = true }: { token?: string; enabled?: boolean }) => {
	const { apiClient } = useApiClientContext();

	return useQuery({
		enabled: enabled && !!token,
		queryFn: () => apiClient.get<string>(`sharedFileLink/byToken/logo?${toQueryString({ token })}`),
		queryKey: [QUERY_KEY, token],
		refetchOnWindowFocus: false,
		retry: false,
	});
};
